import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconVsdSizeM from './FileIconVsd_size_m';
import FileIconVsdSizeS from './FileIconVsd_size_s';

export const FileIconVsd = createFileIcon({
  m: FileIconVsdSizeM,
  s: FileIconVsdSizeS,
  name: 'FileIconVsd',
});
